import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import SuccessLayout from '@shared/components/SuccessLayout';
import Rooms from './Rooms';
import BookingPurchaseSummary from './BookingPurchaseSummary';
import BookingDoneDetail from './BookingDoneDetail';
import ContactCard from './ContactCard';
import BookingPurchaseSkeleton from './BookingPurchaseSkeleton';

import {
  getBookingRoomsDetails,
  getBookingVoucher,
} from '@shared/services/services';
import BoxContainer from '@shared/components/BoxContainer';

const Contenido = ({ datos = {}, showBookingDetails = true }) => {
  const {
    pricesDetail,
    id_integration,
    room,
    subsidiary,
    bookingResponse,
    pagos,
    price,
    cardData,
    cancelationFee,
    validate,
  } = datos;

  const [rooms, setRooms] = useState(null);
  const [hotelVoucher, setHotelVoucher] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const pageConfiguration = useSelector(store => store.pageConfiguration);

  const paymentResult = bookingResponse?.paymentResult ?? {};
  const bookingResult = bookingResponse?.bookingResult ?? bookingResponse;
  const transactionId = bookingResponse?.transactionId ?? null;

  const fetchRooms = async () => {
    try {
      if (!bookingResult?.id) throw new Error('No booking ID available');
      const result = await getBookingRoomsDetails(bookingResult?.id);
      setRooms(result?.rooms || []);
    } catch (error) {
      console.error('fetchRooms error:', error);
      setRooms([]);
    }
  };

  const fetchHotelVoucher = async () => {
    setIsLoading(true);
    try {
      const result = await getBookingVoucher({
        bookingLocator: bookingResult?.locator,
        id_integration,
      });
      setHotelVoucher(result);
    } catch (e) {
      console.error('Error', e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bookingResult?.id) {
      fetchRooms();
    }
  }, [bookingResult?.id]);

  useEffect(() => {
    if (bookingResult?.bookingCode && transactionId) {
      fetchHotelVoucher();
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  if (!showBookingDetails) {
    return null;
  }

  if (isLoading) {
    return <BookingPurchaseSkeleton />;
  }

  return (
    <SuccessLayout>
      {/* LEFT CONTENT */}
      <>
        {/* Detalle de compra */}
        <BookingDoneDetail
          subsidiary={subsidiary}
          paymentResult={paymentResult}
          bookingResult={bookingResult}
          id_integration={id_integration}
          transactionId={transactionId}
          pricesDetail={pricesDetail}
          room={room}
          datos={datos}
          pagos={pagos}
          cancelationFee={cancelationFee}
          hotelsValidateResult={validate}
        />

        {/* En desktop, Rooms aparece abajo */}
        {rooms && (
          <Box sx={{ display: { xs: 'none', md: 'block' }, mt: 2 }}>
            <Rooms rooms={rooms} />
          </Box>
        )}
      </>

      {/* RIGHT CONTENT */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        {/* BOX 1 - Resumen de compra */}
        <BoxContainer>
          <BookingPurchaseSummary
            paymentResult={paymentResult}
            transactionId={transactionId}
            price={price}
            pagos={pagos}
            cardData={cardData}
          />

          {/* En mobile, Rooms aparece dentro del box */}
          {rooms && (
            <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 2 }}>
              <Rooms rooms={rooms} />
            </Box>
          )}
        </BoxContainer>

        {/* BOX 2 - Contacto */}
        <BoxContainer>
          <ContactCard
            pageConfiguration={pageConfiguration}
            subsidiary={subsidiary}
            datos={datos}
            code={bookingResult?.bookingCode}
            transactionId={transactionId}
            hotelVoucher={hotelVoucher}
            bookingResult={bookingResult}
            id_integration={id_integration}
          />
        </BoxContainer>
      </Box>
    </SuccessLayout>
  );
};

export default Contenido;
